import { Link } from 'react-router-dom';
import { Grid, Card, CardActionArea, CardContent, Typography, Button, Alert, Stack } from '@mui/material';
import { Store, DeliveryDining, DirectionsCar, PhoneAndroid, RateReview, Handyman } from '@mui/icons-material';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import { PARTNER_SERVICE_CONFIG } from '../../constants/partnerServices';

const ICONS: Record<string, React.ReactNode> = {
  driver: <DirectionsCar />,
  merchant: <Store />,
  delivery_partner: <DeliveryDining />,
  service_provider: <Handyman />,
};

const COLORS: Record<string, string> = {
  driver: '#2563eb',
  merchant: '#ea580c',
  delivery_partner: '#16a34a',
  service_provider: '#7c3aed',
};

const DESCRIPTIONS: Record<string, string> = {
  driver: 'Zone → Vehicle (brand/model) → KYC & RC docs → Bank → Approval',
  merchant: 'Restaurant, grocery, GST, bank',
  delivery_partner: 'Vehicle, documents, service area, bank details',
  service_provider: 'Skills, documents, service area, bank details',
};

export default function OnboardingHubPage() {
  return (
    <PageShell>
      <PageHeader
        gradient
        eyebrow="Onboarding"
        title="Onboarding Hub"
        subtitle="Preview partner registration flows. Partner self-profile lives under Account for partner logins only — not as an admin onboarding step."
        actions={
          <Stack direction="row" spacing={1}>
            <Button component={Link} to="/config/documents" variant="outlined" startIcon={<RateReview />}>Review Queue</Button>
            <Button component={Link} to="/partners" variant="contained">Manage Partners</Button>
          </Stack>
        }
      />

      <Alert severity="info" icon={<PhoneAndroid />} sx={{ mb: 2 }}>
        Partners should complete onboarding in the <strong>mobile app</strong> (login as customer, then Partner Onboarding).
        Use <strong>Partners by Service → Add Partner</strong> for admin-created accounts. Flows below are for preview/testing only.
      </Alert>

      <Grid container spacing={2.5}>
        {PARTNER_SERVICE_CONFIG.map((form) => (
          <Grid item xs={12} sm={6} md={3} key={form.formCode}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea component={Link} to={`/onboarding/${form.formCode}`} sx={{ height: '100%', p: 2 }}>
                <CardContent>
                  <Typography sx={{ color: COLORS[form.key], mb: 1 }}>{ICONS[form.key]}</Typography>
                  <Typography variant="h6" fontWeight={700}>{form.label}</Typography>
                  <Typography variant="body2" color="text.secondary">{DESCRIPTIONS[form.key]}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </PageShell>
  );
}
